var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 165,
    viewBox: "0 0 173 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 172.5,
    height: 164.5,
    rx: 11.75,
    fill: "url(#paint0_linear_98_5192)",
    stroke: "#636363",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 75V83H67V75H75ZM91 75V83H83V75H91ZM107 75V83H99V75H107ZM115 47C117.122 47 119.157 47.8429 120.657 49.3431C122.157 50.8434 123 52.8783 123 55V111C123 113.122 122.157 115.157 120.657 116.657C119.157 118.157 117.122 119 115 119H59C54.56 119 51 115.4 51 111V55C51 52.8783 51.8429 50.8434 53.3431 49.3431C54.8434 47.8429 56.8783 47 59 47H63V39H71V47H103V39H111V47H115ZM115 111V67H59V111H115ZM75 91V99H67V91H75ZM91 91V99H83V91H91ZM107 91V99H99V91H107Z",
    fill: "#FCFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_98_5192",
    x1: 6.39449,
    y1: 82.4999,
    x2: 173.349,
    y2: 82.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleDetails);
export default __webpack_public_path__ + "static/media/schedule-details.1fd679b9b7a05f63de3a0de159e74843.svg";
export { ForwardRef as ReactComponent };